module.exports = __webpack_public_path__ + "img/image45.3d4143b2.png";